import { AccessorsMutatorsDecorator } from "../../helpers";
import { TranslatableModel } from "./translatable-model";
import { Property } from "./property.model";
import { User } from "./user.model";

/**
 * @class CashDrawer
 */
export class CashDrawer extends TranslatableModel {

    static get STATUS_ACTIVE() {

        return 1;
    }

    static get STATUS_INACTIVE() {

        return 0;
    }

    static get CONDITION_OPENED() {

        return 1;
    }

    static get CONDITION_CLOSED() {

        return 0;
    }

    /**
     * @type {string[]}
     */
    static get translatableAttributes() {

        return [ 'name' ];
    }

    static get validationModel() {

        return {
            name: {
                label: 'DRAWER_NAME_IN_ENGLISH'
            },
            name_ar: {
                label: 'DRAWER_NAME_IN_ARABIC'
            }
        };
    }

    /**
     * @param {Object|Property} value
     * @returns {Property}
     */
    setProperty(value) {

        return value instanceof Property ? value : new Property(value);
    }

    /**
     * @param {Object|User} value
     * @returns {User}
     */
    setUser(value) {

        return value && (value instanceof User ? value : new User(value));
    }

    formatShiftId() {

        if (!this.shift_id) {

            return this.shift_id;
        }

        let id = new String(this.shift_id);

        while (id.length < 6) {

            id = '0' + id;
        }

        return id;
    }
}

AccessorsMutatorsDecorator('id', ...CashDrawer.translatableAttributesWithLanguageAliases, 'property', 'property_id', 'status',
    'user', 'user_name', 'user_id', 'condition', 'current_balance', 'last_closing_balance', 'times_opened', 'opened_at',
    'closed_at', 'shift_id', 'shift_diff', 'shifts')(CashDrawer);


// WEBPACK FOOTER //
// ./src/pms-api/models/cash-drawer.model.js